import { type FC } from "react";

import { PDF_EXTENSION, PDF_MIME_TYPE } from "@application/utilities/file";

import { FilePicker } from "@styled/file_picker";
import { FilePickerGuide } from "@styled/file_picker_guide";

const PDF_ACCEPT = [PDF_EXTENSION, PDF_MIME_TYPE].join(",");

/**
 * Comprehensive-evaluation upload entry point. Caller wraps in `FileManager`.
 *
 * The follow-up flow used to share this component as a discriminated-union
 * variant; it now lives in `FollowUpUploadStage` so each zone can render
 * independently as drops swap to file pills (per design handoff D10).
 *
 * `title` is the ACTION — the surrounding RecordsStatusBar names the lane.
 * PDF-only `accept` is the point of a per-call-site prop: an identical picker
 * across the three lanes is how audio lands in the records bucket.
 */
export const RecordsUploadZone: FC = () => (
  <FilePicker
    title="Upload your medical records"
    action="Upload records"
    accept={PDF_ACCEPT}
  >
    <FilePickerGuide
      steps={[
        {
          label: "Upload records",
          description: "Drop your PDF here",
        },
        {
          label: "Organize and excerpt",
          description: "Sorted by date, key details extracted",
        },
        {
          label: "Analyze with Records Assistant",
          description: "Ask questions, pinpoint details",
        },
      ]}
    />
  </FilePicker>
);
